import React from 'react'

import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  MinusCircleIcon,
  QuestionMarkCircleIcon,
  XCircleIcon,
} from '@heroicons/react/20/solid'

export function AuditCheckStatusRenderer({ value }: { value: string }) {
  const lookup = {
    'audited-match': (
      <CheckCircleIcon
        width={22}
        height={22}
        className='text-green-500'
      />
    ),
    'audited-mismatch': (
      <XCircleIcon
        width={22}
        height={22}
        className='text-red-500'
      />
    ),
    'not-required': (
      <MinusCircleIcon
        width={22}
        height={22}
        className='text-gray-300'
      />
    ),
    'data-unavailable': (
      <QuestionMarkCircleIcon
        width={22}
        height={22}
        className='text-blue-400'
      />
    ),
    undefined: (
      <ExclamationTriangleIcon
        width={22}
        height={22}
        className='text-yellow-400'
      />
    ),
  }

  return <div className='h-full flex justify-center items-center'>{lookup[value]}</div>
}
